// The footer's copyright line, DERIVED — never a literal that quietly expires.
//
// The footer read "© 2025 Locate Now, LLC" throughout 2026 because the year was
// typed into JSX. Nothing could catch that: a hard-coded year is correct on the
// day it is written and wrong every January afterwards, and no test asserted
// the year at all. The rule this file encodes is that the CURRENT year is a
// fact about the clock, so it has to be read from the clock.
//
// The start year stays a constant because it is a real historical fact about
// the company and must NOT drift with the clock — deriving it too would make
// the range collapse to "© 2026" and silently discard the earlier claim.

/** First year of publication. A fixed historical fact, deliberately literal. */
export const COPYRIGHT_START_YEAR = 2025;

/**
 * "© 2025 Locate Now, LLC. All rights reserved." in the start year, and
 * "© 2025–2026 Locate Now, LLC. All rights reserved." in every year after.
 *
 * `now` is injectable so the test can pin a date instead of asserting against
 * whatever today happens to be — a test that reads the same clock as the code
 * agrees with a broken implementation.
 */
export function copyrightLine(now: Date = new Date()): string {
  const current = now.getFullYear();
  const years =
    current > COPYRIGHT_START_YEAR
      ? `${COPYRIGHT_START_YEAR}–${current}`
      : String(COPYRIGHT_START_YEAR);
  return `© ${years} Locate Now, LLC. All rights reserved.`;
}
